import { useState } from "react";
import svgDoc from "../../assets/images/svg-Docs.svg";
import { FiX, FiSearch } from "react-icons/fi";
import { IoDocumentTextOutline } from "react-icons/io5";
import { Container } from "./styles";
import { DocSideTypes } from "./types";

export const DocsSide = ({ docs }: DocSideTypes) => {
	//TODO arrumar tipagem
	const [show, setShow] = useState(true);
	const [showSearch, setShowSearch] = useState(true);
	const [selectedDoc, setSelectedDoc] = useState(docs ? docs[0] : null);
	const [searchedDoc, setSearchedDoc] = useState("");

	function filterDocs(text: string) {
		let txtUpper = text.toUpperCase();
		setSearchedDoc(txtUpper);
	}

	return (
		<Container className='docs-side'>
			<iframe
				src={selectedDoc?.location}
				frameBorder={0}
				title='docs_frame'
			/>

			<div className='select-docs'>
				<button className='docs-button' onClick={() => setShow(true)}>
					<img src={svgDoc} id='button-icon' alt='doc_placeholder' />
				</button>
			</div>

			<div className={`menu ${show ? "show" : "hidden"}`}>
				<div className='doc-bg'>
					<div className='doc-header-wrapper'>
						<h2 className='doc-header'>
							Selecione o documento para ser visualizado
						</h2>

						<div className='doc-button'>
							<button
								id='exit-docs'
								onClick={() => setShow(false)}>
								<FiX />
							</button>
						</div>
					</div>

					<div className='search-container'>
						<div className='button-menu'>
							<button
								className={`button ${
									showSearch ? "show" : "hidden"
								}`}
								id='search'>
								<div className='search-wrapper'>
									<div
										className='icon-wrapper'
										onClick={() =>
											setShowSearch((state) => !state)
										}>
										<FiSearch />
									</div>
									<div className='input-wrapper'>
										<input
											type='text'
											placeholder='Pesquise por documentos...'
											onChange={(e) => {
												filterDocs(e.target.value);
											}}
										/>
									</div>
								</div>
							</button>
						</div>
					</div>

					<div className='out-docs'>
						{docs && docs.length ? (
							<>
								{docs?.map((doc) => {

									if (doc.documentTag !== null) {
										let docTag = doc.documentTag.name;
										let upperCS = docTag.toUpperCase();

										if (
											upperCS.includes(searchedDoc) &&
											doc.documentTagId
										) {
										}

										return (
											<div
												key={`${doc.name}`}
												className='file-doc'
												onClick={() =>
													setSelectedDoc(doc)
												}
												style={
													doc.location ===
													selectedDoc?.location
														? {
																backgroundColor:
																	"#dddddd",
														  }
														: {}
												}>
												<h4>{doc.documentTag.name}</h4>
											</div>
										);
									}

									return;
								})}
							</>
						) : (
							<>
								<IoDocumentTextOutline size={"10rem"} />
								<p>Nenhum documento por aqui...</p>
							</>
						)}
					</div>
				</div>
			</div>
		</Container>
	);
	// )
};
